export const BRAND_NAME = 'MockReady';
export const BRAND_NAME_SHORT = 'MB';

export const frequently_asked_questions = {
  "General": [
    {
      "question": "What is the IELTS Speaking Practice Platform?",
      "answer": "The IELTS Speaking Practice Platform is an online hub designed to enhance your English speaking skills, specifically for the IELTS (International English Language Testing System) exam. Explore features and resources to boost your spoken English proficiency."
    },
    {
      "question": "Is the platform free to use?",
      "answer": "Absolutely! Our platform is entirely free, providing accessible and valuable resources for English learners gearing up for the IELTS speaking test, including Practice English Speaking Free."
    },
    {
      "question": "How can I get started?",
      "answer": "Simply sign up for an account on our platform. Once logged in, dive into various speaking practice materials, initiating your journey towards Improving English Speaking Skills."
    },
    {
      "question": "Do I need any special equipment or software to use the platform?",
      "answer": "No special requirements! All you need is a computer or mobile device with an internet connection and a microphone. Our platform operates directly in your web browser, eliminating the need for additional software."
    }
  ],
  "Using the Platform": [
    {
      "question": "What resources are available for practicing speaking?",
      "answer": "Our platform offers diverse resources, including sample speaking questions, cue cards, and practice tests. Schedule and join mock interview sessions to simulate real IELTS speaking tests, fostering English Speaking Practice Conversation."
    },
    {
      "question": "How do mock interview sessions work?",
      "answer": "Engage in interactive sessions where you pair with another user preparing for the IELTS speaking test. Play roles of examiner and candidate, gaining familiarity with the format and timing of the IELTS speaking test."
    },
    {
      "question": "Can I record my speaking responses?",
      "answer": "Absolutely! Record your responses during mock interview sessions to review, assess, and track your progress over time. A valuable feature for Practice English Speaking Online."
    },
    {
      "question": "Are there any scoring or feedback mechanisms?",
      "answer": "While official IELTS scores aren't provided, users can rate and provide feedback on each other's responses after mock interview sessions. Peer feedback is instrumental in identifying strengths and weaknesses for Improving English Speaking Online."
    }
  ],
  "Improving English Speaking Skills": [
    {
      "question": "How can I improve my English speaking skills with this platform?",
      "answer": "Practice regularly through mock interview sessions, use sample questions and cue cards, and seek feedback from other users. Consistent practice is the key to success in Improving English Speaking Skills Online."
    },
    {
      "question": "Do you provide tips and strategies for the IELTS speaking test?",
      "answer": "Certainly! Find valuable guidance on structuring your responses, managing time effectively, and showcasing language proficiency for IELTS Speaking Topics."
    }
  ],
  "Support and Contact": [
    {
      "question": "I have a question or need assistance. How can I contact support?",
      "answer": "Reach out to our support team at support@mockready.com.com for any questions or concerns. We're dedicated to helping you maximize your IELTS Speaking Practice Experience."
    },
    {
      "question": "Is there a community or forum for users to interact and share tips?",
      "answer": "Absolutely! Join our community forum to interact with fellow English learners, share tips, and discuss your IELTS preparation journey. A great way to connect with others on the path to English Speaking Practice Website."
    }
  ]
}


export const cueCardsFAQ  = [
  {
    "question": "Why are IELTS Cue Cards crucial to the speaking test?",
    "answer": "IELTS Cue Cards are crucial as they require spontaneous oration on various topics, showcasing language proficiency and quick thinking skills."
  },
  {
    "question": "How can I get started with MockReady for IELTS Cue Cards practice?",
    "answer": "Visit our IELTS cue cards segment, sign up, and proceed on your journey to mastering cue cards."
  },
  {
    "question": "Why should I choose MockReady for my IELTS Cue Cards preparation?",
    "answer": "We offer a comprehensive and structured approach, various topics, and a supportive community, making us the ideal choice to master IELTS cue cards."
  },
  {
    "question": "What's the key to success with MockReady for Cue Cards practice?",
    "answer": "Our secret to success lies in consistent practice, self-evaluation, community engagement, and a commitment to enhancing your IELTS speaking skills."
  },
  {
    "question": "Is MockReady suitable for beginners in IELTS Cue Cards practice?",
    "answer": "MockReady caters to all levels of IELTS aspirants, providing resources and support to help beginners excel in cue cards."
  }
]

export const speakingTopicsFAQ = [
  {
    "question": "What is MockReady's role in IELTS question topic preparation?",
    "answer": "MockReady is a valuable resource for mastering IELTS question topics, offering strategies, resources, and expert insights to help you champion the IELTS exam."
  },
  {
    "question": "What are the sorts of question topics covered in the IELTS test?",
    "answer": "The IELTS test envelops various question topics, including social networking, education, sports, innovation, health, and more."
  },
  {
    "question": "Why should I choose MockReady for IELTS question topic preparation?",
    "answer": "MockReady offers various benefits, including diverse question topics, expert guidance, structured practice exercises, sample answers, and actual test simulations, ensuring comprehensive preparation and readiness for the IELTS exam."
  },
  {
    "question": "How can I make the most of MockReady's question topics practice?",
    "answer": "Select a question topic best aligning with your interests or practice goals. Follow structured practice, self-evaluate your performance, and focus on improvement. Join the MockReady learner community for collaborative learning."
  }
]

export const sampleSpeakingExamsFAQ = [
  {
    "question": "Why is clearing the IELTS speaking test significant?",
    "answer": "Clearing the test is vital for achieving your ideal IELTS score and improving your general English-talking skills."
  },
  {
    "question": "What makes MockReady's sample speaking exams diverse?",
    "answer": "MockReady offers a wide range of sample speaking exams covering various topics and scenarios, allowing you to practice different question types effectively."
  },
  {
    "question": "What does \"structured practice\" mean in the context of MockReady's resources?",
    "answer": "MockReady offers structured practice exercises for each part of the speaking exams, helping you get accustomed to the format and time constraints of the actual exam."
  },
  {
    "question": "What should you focus on when practicing with MockReady's sample speaking exams?",
    "answer": "When practicing with MockReady's sample speaking exams, focus on speech fluency, cohesiveness, and vocabulary usage."
  }
]

export const speakingExamMaterialsFAQ = [
  {
    "question": "What types of IELTS speaking examination materials does MockReady offer?",
    "answer": "MockReady provides a variety of IELTS speaking examination materials, including sample questions, cue cards, and full-length practice tests. These materials encompass various topics and scenarios to facilitate adequate preparation."
  },
  {
    "question": "How can I access MockReady's IELTS speaking examination materials?",
    "answer": "You can register on our platform and explore our comprehensive collection of IELTS speaking examination materials. Many of these materials are available for free to support your examination preparation."
  },
  {
    "question": "Does MockReady offer expert insights and guidance for the IELTS speaking examination?",
    "answer": "Yes, MockReady offers expert insights, tips, and strategies for each section of the IELTS speaking examination to help you comprehend its specific requirements and expectations and perform at your best."
  },
  {
    "question": "How can I monitor my progress using MockReady's IELTS speaking examination materials?",
    "answer": "You can track your progress by regularly evaluating your performance against the provided guidelines and sample answers and taking notes on areas that require improvement."
  }
]


  export const introductionQuestions = [
    'May I know your full name?',
    'How may I address you?',
    'May I see your ID?',
    'Where do you come from?',
]

export const userGuideSteps = [
    {
        title: 'Welcome to MockReady',
        key: 'welcome',
        content: 'Welcome to MockReady, your go-to platform for IELTS speaking practice. Get ready to enhance your English speaking skills and ace your IELTS speaking test!',
    },
    {
        title: 'Background Information',
        key: 'background',
        content: 'Before we begin, please provide some background information about yourself. This will help us personalize your practice experience.',
    },
    {
        title: 'Purpose of Practice',
        key: 'purpose',
        content: 'What is your purpose for practicing English speaking? Are you preparing for the IELTS speaking test or simply looking to improve your English speaking skills?',
    },
    {
        title: 'Account Verification',
        key: 'verification',
        content: 'To ensure a seamless practice experience, we need to verify your account. Please provide your email address and verify your account to proceed.',
    },
]


